/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:24
 * @LastEditors: zc
 * @LastEditTime: 2023-11-01 16:18:04
 */
// import HeaderMain from '@/views/layout/HeaderMain.vue';
import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/login',
  name: 'login',
  meta: {
    title: '登录',
    noCache: true,
    moreFlag: true
  },
  component: function component() {
    return import('@/views/login/Login.vue');
  }
}, {
  path: '/logintx',
  name: 'logintx',
  meta: {
    title: '登录',
    noCache: true,
    moreFlag: true
  },
  component: function component() {
    return import('@/views/login/LoginFromTx.vue');
  }
}, {
  path: '/authorize',
  name: 'authorize',
  meta: {
    title: '用户权限验证',
    noCache: true,
    moreFlag: true
  },
  component: function component() {
    return import('@/views/login/authorize.vue');
  }
}, {
  path: '/logout',
  name: 'logout',
  component: function component() {
    return import('@/views/login/Logout.vue');
  },
  meta: {
    title: '退出登录',
    noCache: true,
    moreFlag: true
  }
}, {
  path: '/phoneRetrieval',
  component: HeaderPaddingMain,
  name: 'phoneRetrieval',
  meta: {
    title: '手机号找回',
    noCache: true,
    moreFlag: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/login/PhoneRetrieval.vue');
    }
  }]
}, {
  path: '/certificateRetrieval',
  component: HeaderPaddingMain,
  name: 'certificateRetrieval',
  meta: {
    title: '证件找回',
    noCache: true,
    moreFlag: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/login/CertificateRetrieval.vue');
    }
  }]
}, {
  path: '/retrieval',
  component: function component() {
    return import('@/views/login/retrieval.vue');
  },
  name: 'retrieval',
  meta: {
    title: '密码找回',
    noCache: true,
    moreFlag: true
  }
}];
export default router;